var exports = {
  "kL": "MobileBottomNav.module__container___NVo0N1",
  "oi": "MobileBottomNav.module__navButton___NVo0N1",
  "Mv": "MobileBottomNav.module__navButtonActive___NVo0N1",
  "XA": "MobileBottomNav.module__navButtonInactive___NVo0N1",
  "VK": "MobileBottomNav.module__voiceButton___NVo0N1",
  "Kk": "MobileBottomNav.module__icon___NVo0N1",
  "Pf": "MobileBottomNav.module__label___NVo0N1",
};

module.exports = exports;
